import React from "react";
import { AccountRolePresence } from "@common/types/domains/accounting/account";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

const accountRolePresences: string[] = Object.values(AccountRolePresence);

function isAccountRolePresence(
    value: FilterMultiselectValue,
): value is AccountRolePresence {
    return typeof value === "string" && accountRolePresences.includes(value);
}

const options: FilterMultiselectOption[] = [
    {
        value: AccountRolePresence.HAS_ROLE,
        label: "Has role",
        searchableLabel: "has role",
    },
    {
        value: AccountRolePresence.NO_ROLE,
        label: "No role",
        searchableLabel: "no role",
    },
];

export const AccountRolePresenceFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value = filters.accountRolePresence
        ? [filters.accountRolePresence]
        : [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    if (val.length === 0) {
                        onChange({ accountRolePresence: undefined });
                        return;
                    }
                    const added = val.find(
                        (v): v is AccountRolePresence =>
                            v !== filters.accountRolePresence &&
                            isAccountRolePresence(v),
                    );
                    const first = val[0];
                    const fallback = isAccountRolePresence(first)
                        ? first
                        : undefined;
                    onChange({ accountRolePresence: added ?? fallback });
                }}
                name="accountRolePresence"
                onBlur={noop}
            />
        </div>
    );
};
